<template>  
     <h1>ljdh</h1>
</template>

<script setup>

definePageMeta({
    layout: false,
})
</script>